import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchAreas'
})
export class SearchAreasPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if(!items) return [];
    if(!searchText) return items;
searchText = searchText.toLowerCase();
return items.filter( it => {
      return it.area_name.toLowerCase().includes(searchText);
    });
   }

}
